

























































































import { Component, Mixins } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import { AuthModule } from "@/store/auth.module";

@Component({})
export default class PayInstruction extends Mixins(FormValidator) {
  //
  get showInstrDialog() {
    return AuthModule.ShowInstruction;
  }
  set showInstrDialog(val) {
    AuthModule.setShowInstruction(val);
  }
  get isKz() {
    return this.$i18n.locale === "kk";
  }
}
